import React, { PureComponent } from "react";
import { Radio, Input, Select, Layout, Checkbox } from 'element-react';
import Paging from 'components/Paging'

import 'element-theme-default';
require("./index.css");

//意见征求
export default class Consultation extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      active: 0,
      radioValue: 1,
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      value: 1,
      isCheck: false,
      dialogVisible0: false,
      dialogVisible2: false,
      dialogVisible3: false
    }
  }



  check() {
    let { isCheck, } = this.state;
    this.setState({
      isCheck: !isCheck,
    })
  }

  next() {
    this.setState({
        dialogVisible2: true,
      })
  }

  onChange(value) {
    this.setState({ value });
  }

 
  renderForm() {
    return (
      <form className="">
        <div className="table">
          <Layout.Row type="flex" className="row-bg title" style={{ fontWeight: 500 }}>
            <Layout.Col span="24">退役军人的医疗保障方面如何开展工作能更好的保障退役军人的医疗，同时又不影响大众人民的基本权益？</Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="4" className="left">姓名<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="6"><Input className="w160" placeholder="请输入姓名" /></Layout.Col>
            <Layout.Col span="6" className="middle">
              <span style={{ paddingRight: '20px' }}>性别</span>
              <Radio value="1" checked={this.state.value === 1} onChange={this.onChange.bind(this)}>男</Radio>
              <Radio value="2" checked={this.state.value === 2} onChange={this.onChange.bind(this)}>女</Radio>
            </Layout.Col>
            <Layout.Col span="8" className="exception">
              <span>身份证号<i className="red_star">*</i></span>
              <Input placeholder="请输入18位身份证号" />
            </Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="4" className="left">联系地址<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="20">
              <Select value={this.state.value} placeholder="请选择" className="w160">
                {
                  this.state.options.map(el => {
                    return <Select.Option key={el.value} label={el.label} value={el.value} />
                  })
                }
              </Select>
            </Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="4" className="left">电子邮箱<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="12"><Input className="w240" placeholder="请输入电子邮箱" /></Layout.Col>
            <Layout.Col span="8" className="exception">
              <span>邮政编码<i className="red_star">*</i></span>
              <Input placeholder="请输入邮政编码" />
            </Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="4" className="left">内容<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="20">
              <Input
                type="textarea"
                autosize={{ minRows: 6 }}
                placeholder="不超过500字"
                className="textarea"
              />
            </Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="4" className="left">手机号码<i className="red_star">*</i></Layout.Col>
            <Layout.Col span="6"><Input className="w160" placeholder="请输入手机号码" /></Layout.Col>
            <Layout.Col span="6" className="middle">
              <span>验证码</span>
            </Layout.Col>
            <Layout.Col span="8" className="exception code_box">
              <Input placeholder="请输入验证码" />
              <button type="button" className="code_btn">获取验证码</button>
            </Layout.Col>
          </Layout.Row>

          <Layout.Row type="flex" className="row-bg">
            <Layout.Col span="24" className="open">
              <span style={{ paddingRight: '20px' }}>是否匿名发布（默认为是）<i className="red_star">*</i></span>
              <Radio value="1" checked={this.state.value === 1} onChange={this.onChange.bind(this)}>是</Radio>
              <Radio value="2" checked={this.state.value === 2} onChange={this.onChange.bind(this)}>否</Radio>
            </Layout.Col>
          </Layout.Row>
        </div>
        <div className="submit_box">
          <button type="button" className="submit_btn">提交</button>
        </div>
      </form>
    )
  }


  renderOpinion() {
    return (
      <div className="opinion">
        <ul>
          <li onClick={() => this.next()}>1、退役军人的医疗保障方面如何开展工作能更好的保障退役军人的医疗，同时又不影响大众人民的基本权益？</li>
          <li onClick={() => this.next()}>2、对于退役军人的养老工作有什么提议？</li>
        </ul>
        <Paging total={2} pageSize={10} currentPage={1} />
      </div>
    )
  }


  render() {
    let {dialogVisible2 } = this.state;

    return (
      <div className="content_list">
        {!dialogVisible2 ? this.renderOpinion() : dialogVisible2 ? this.renderForm(): null}
        
      </div>
    );
  }
}
